import React from 'react';
import ProductLayout from '../../../../../layout/Product';
import DROPSHIPPING_REQUEST_COMPANY from '../../../../../components/constant/dropshippingRequestCompany';
import DropshipperTable from '../_module/DropshipperTable';

export default () => (
  <ProductLayout
    main={
      <DropshipperTable status={DROPSHIPPING_REQUEST_COMPANY.STATUS.PENDING} />
    }
  />
);
